module.exports = __webpack_public_path__ + "static/media/old india-avenue-i.7ba8d575.csv";